import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
/* stylelint-disable no-descending-specificity -- This rule breaks when you have multiple complex styles in one file. */

import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { styleUtils } from '../styles';
var defaultFocusCss = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t:focus > :first-of-type {\n\t\t", "\n\t}\n"])), css(styleUtils.focusOutsetThick));
export var StyledFocusable = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\toutline: none;\n\t> :focus {\n\t\toutline: none;\n\t}\n\t", ";\n"])), function (props) {
  return !props.className && defaultFocusCss;
});